/**
 * The date readers see on an article: when it was last edited, or when it was published if never edited.
 */
export function articleDate(article) {
  if (article?.content_updated_at) return { label: "Updated", date: article.content_updated_at };
  if (article?.created_at) return { label: "Published", date: article.created_at };
  return null;
}
